import React from 'react'
import { useSelector } from 'react-redux'

import selectors from 'store/selectors'
import Loading from 'components/system/Loading'

import LayoutMain from 'pages/Layout'

import Route from './Route'
import RouteContext from './RouteContext'

import NotFound from 'pages/NotFound'
import Login from 'pages/auth/Login'

import Payment from 'pages/account/Payment'

import ProjectList from 'pages/project/List'
import ProjectEdit from 'pages/project/Edit'

import ClientList from 'pages/client/List'
import ClientEdit from 'pages/client/Edit'

import ResourceTree from 'pages/resource/Tree'
import ResourceList from 'pages/resource/List'
import ResourceEdit from 'pages/resource/Edit'

import QuoteList from 'pages/quote/List'
import QuoteEdit from 'pages/quote/Edit'
import QuoteDetails from 'pages/quote/Details'
import QuoteTree from 'pages/quote/Tree'
import QuoteTasks from 'pages/quote/Tasks'
import QuoteMaterials from 'pages/quote/Materials'
import QuoteHire from 'pages/quote/Hire'
import QuoteTasksExport from 'pages/quote/TasksExport'
import QuoteMaterialsExport from 'pages/quote/MaterialsExport'
import QuoteHireExport from 'pages/quote/HireExport'

const Router = ({

}) => {
  const userLoaded = useSelector(selectors.user.loaded)
  const route = useSelector(selectors.router.route)
  const fullRoute = useSelector(selectors.router.fullRoute)

  if(!userLoaded || !route) return <Loading />

  let routes = (
    <>
      <Route segment="notfound" exact>
        <NotFound />
      </Route>
      <Route segment="login" exact>
        <Login />
      </Route>
      <Route segment="payment" exact>
        <Payment />
      </Route>
      <Route segment="project">
        <Route segment="list" exact>
          <ProjectList />
        </Route>
        <Route segment="edit" exact>
          <ProjectEdit />
        </Route>
      </Route>
      <Route segment="client">
        <Route segment="list" exact>
          <ClientList />
        </Route>
        <Route segment="edit" exact>
          <ClientEdit />
        </Route>
      </Route>
      <Route segment="resource">
        <ResourceTree>
          <Route segment="list" exact>
            <ResourceList />
          </Route>
          <Route segment="edit" exact>
            <ResourceEdit />
          </Route>
        </ResourceTree>
      </Route>
      <Route segment="quote">
        <Route segment="list" exact>
          <QuoteList />
        </Route>
        <Route segment="create" exact>
          <QuoteDetails />
        </Route>
        <Route segment="export" exact>
          <QuoteTasksExport />
        </Route>
        <Route segment="export_materials" exact>
          <QuoteMaterialsExport />
        </Route>
        <Route segment="export_hire" exact>
          <QuoteHireExport />
        </Route>
        <Route segment="edit">
          <QuoteEdit>
            <Route segment="details" exact>
              <QuoteDetails />
            </Route>
            <Route segment="materials" exact>
              <QuoteMaterials />
            </Route>
            <Route segment="hire" exact>
              <QuoteHire />
            </Route>
            <Route segment="folder">
              <QuoteTree>
                <Route segment="tasks" exact>
                  <QuoteTasks />
                </Route>
              </QuoteTree>
            </Route>
          </QuoteEdit>
        </Route>
      </Route>
    </>
  )

  if(!fullRoute.disableToolbar) {
    routes = (
      <LayoutMain>
        { routes }
      </LayoutMain>
    )
  }

  return (
    <RouteContext.Provider value={ route.name }>
      { routes }
    </RouteContext.Provider>
  )
}

export default Router
